/* ════════════════════════════════════════════════════════════════════════════════════════
   PAMIĘĆ WYBRANYCH ZASOBÓW WE WNIOSKU („Utwórz nowe zgłoszenie → Zmiana uprawnień do dysków sieciowych”).

   [przegląd R19, 2026-09-13] Lista zasobów w oknie to WYNIK WYSZUKIWANIA z serwera. Podsumowanie „Wybrane
   dyski” i treść zgłoszenia były składane z tego samego wyniku — więc gdy pracownik wybrał dysk, a potem
   wpisał frazę, która go nie obejmuje, dysk znikał z podsumowania i z TREŚCI zgłoszenia, choć jego id
   zostawał w `selectedDrives` i wniosek o dostęp i tak powstawał. IT dostawało treść niezgodną z wnioskiem.

   Rozwiązanie: karta pamięta każdy zasób, który widziała w odpowiedziach listy (`zapamietajDyski`),
   a wybrane składa z bieżącego wyniku, a gdy go tam nie ma — z pamięci (`wybraneDyski`).
   Kolejność = kolejność wyboru.
   ════════════════════════════════════════════════════════════════════════════════════════ */

const dyskiZGrup = (grupy) =>
    (Array.isArray(grupy) ? grupy : []).flatMap((g) => (Array.isArray(g?.drives) ? g.drives : []));

/** Dokłada do `mapa` (Map id → zasób) wszystkie zasoby z odpowiedzi `/my-tickets/all-drives-grouped`. */
export const zapamietajDyski = (mapa, grupy) => {
    if (!mapa) return mapa;
    dyskiZGrup(grupy).forEach((d) => {
        if (d && d.id != null) mapa.set(d.id, d);
    });
    return mapa;
};

/**
 * Wybrane zasoby jako obiekty — z bieżącego wyniku listy, a gdy wyszukiwanie go odfiltrowało, z pamięci karty.
 * Nie modyfikuje `mapa` (bezpieczne w renderze).
 */
export const wybraneDyski = (mapa, wybrane, grupy) => {
    const biezace = zapamietajDyski(new Map(), grupy);
    return (Array.isArray(wybrane) ? wybrane : [])
        .map((id) => biezace.get(id) || mapa?.get?.(id))
        .filter(Boolean);
};
